// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__iDFIv","spin":"Loader_spin__E4RJ0","container":"Loader_container__X02md","loading":"Loader_loading__Rb1OM","fadein":"Loader_fadein__e7aHS"};